// TODO enable eslint
/* eslint-disable react/sort-comp */
/* eslint-disable react/destructuring-assignment */
import React from "react"
import warning from "warning"

export const Context = React.createContext({})

/* HOC, which provide context data from Overlay */
export const contextConsumer = BaseComponent => props => (
  <Context.Consumer>
    {context => <BaseComponent {...props} overlay={context} />}
  </Context.Consumer>
)

/* This component exposes overlay container, a native element of which can be
accessed by context (You should import Context from this file to use it) */
export default class CardOverlay extends React.Component {
  refEl = React.createRef()

  requiredCount = 0

  /* eslint react/no-unused-state: 0 */
  state = {
    el: null,
    enabled: false,
    enable: props => {
      const { onClose } = props
      warning(
        typeof onClose === `function`,
        `You must pass onClose function, when enable overlayer`,
      )
      document.body.style.overflow = `hidden`
      /* Card can be required by few events at a time (when open new card while
       * preview event still selected) */
      this.requiredCount += 1

      this.setState({
        enabled: !!this.requiredCount,
        cardProps: props,
        handleClose: onClose,
      })
    },
    disable: () => {
      this.requiredCount -= 1

      if (this.requiredCount === 0) {
        document
          .getElementById(`root`)
          .removeEventListener(`mousewheel`, this.preventScroll)
      }

      document.body.style.overflow = ``

      this.setState({
        enabled: !!this.requiredCount,
      })
    },

    /* Allow to register onSelect function from calendar's insides */
    registerChangeSelect: onSelect => {
      this.changeSelect = onSelect
    },
  }

  preventScroll = e => {
    e.preventDefault()
    e.stopPropagation()
  }

  componentDidMount() {
    /* eslint react/no-did-mount-set-state: 0 */
    this.setState({
      el: this.refEl.current,
    })
  }

  render() {
    const { CardComponent } = this.props

    return (
      <div>
        <div>
          <Context.Provider value={this.state}>
            {this.props.children}
          </Context.Provider>
        </div>
        {this.state.enabled && (
          <CardComponent
            {...this.state.cardProps}
            handleItemAdd={this.props.handleItemAdd}
            handleEventRemove={this.props.onEventRemove}
            onSelect={this.changeSelect}
          />
        )}
      </div>
    )
  }
}
